import { required } from "vuelidate/lib/validators";  
const StrIyilestirmeBirim = {
  data() {
    return {
      StrIyilestirmeBirimData: {
        Iyilestirmeid: null,
        Birimid: null,
        Planlananiyilestirme: null,
        Bitisay: null,
        Bitisyil: null,
        Durum: 1,
        Revizyonaciklama: null,
        Kanit: null,
      },
      FormDataType: {
        Iyilestirmeid: { FieldName: "Iyilestirmeid", Field: "combobox", FieldTitle: "İyileştirme", ComboDataArray: [] }, 
        Birimid: { FieldName: "Birimid", Field: "combobox", FieldTitle: "Birim", ComboDataArray: [] },
        Planlananiyilestirme: { FieldName: "Planlananiyilestirme", Field: "textarea", FieldTitle: "Planlanan İyileştirme" },
        Bitisay: { FieldName: "Bitisay", Field: "input", FieldTitle: "Bitiş Ay" },
        Bitisyil: { FieldName: "Bitisyil", Field: "input", FieldTitle: "Bitiş Yıl" }, 
        Revizyonaciklama: { FieldName: "Revizyonaciklama", Field: "textarea", FieldTitle: "Revizyon Açıklamsı" }, 
        Kanit: { FieldName: "Kanit", Field: "textarea", FieldTitle: "Kanıt" },
        Durum: { FieldName: "Durum", Field: "combobox", FieldTitle: "Durum", ComboDataArray: [
          { Id: 1, Value: "İyiştirme Planını Oluşturuldu"},{ Id: 2, Value: "İyiştirme Planını Gönderildi"},{ Id: 3, Value: "İyileştirme Planını Revizyona  Gönderildi"},
          { Id: 4, Value: "İyiştirme Planını Onaylandı"}
        ] },
      },
      DurumEnum: {
        1: "İyileştirme Planını Oluşturuldu",
        2: "İyileştirme Planını Gönderildi ",
        3: "İyileştirme Planını Revizyona  Gönderildi",
        4: "İyileştirme Planını Onaylandı "
      }
    }
  },
  validations: {
    FormData: {
      Iyilestirmeid: { required },
      Birimid: { required },
      Planlananiyilestirme: { required },
      Bitisay: { required },
      Bitisyil: { required },
      Revizyonaciklama: {}, 
      Kanit: {},
    },
    Filter:{ 
      Birimid: { required },
      Iyilestirmeid: {},
      Bitisay: {},
      Bitisyil: {},
      Durum: {}
    }
  },
  created() {
 
 
  }
}
export default StrIyilestirmeBirim